module.exports = __webpack_public_path__ + "media/images/procedure_managements/how_to_create/img_mobile_3-89034d1741e145e5f772b84c2d7f5b68.png";